/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row } from 'antd';
import castArray from 'lodash/castArray';
import FieldContext from 'rc-field-form/es/FieldContext';

import { Typography, Sortable } from '@atoms';
import Form from '@organisms/Form';

import s from './styles.module.less';

const SortableArrayField = ({
  name,
  rules,
  label,
  extra,
  subtitle,
  style,
  titleLevel = 3,
  editPanel: EditPanel,
  withPlaceholder,
  children,
  withCount,
  titleStyle,
  onRelatedEventDelete,
}) => {
  const { prefixName = [], setFields, getFieldValue } = React.useContext(FieldContext);

  const formName = React.useMemo(() => {
    return [...prefixName, ...castArray(name)];
  }, [prefixName, name]);

  const droppableId = React.useMemo(() => {
    return `droppable-${formName.join('.')}`;
  }, [formName]);

  const edit = (index) => {
    const items = getFieldValue(formName);

    setFields([
      {
        name: formName,
        value: items.map((item, i) => ({ ...item, edit: i === index })),
      },
    ]);
  };

  const closeEdit = () => {
    const items = getFieldValue(formName);

    setFields([
      {
        name: formName,
        value: items.map((item) => ({ ...item, edit: false })),
      },
    ]);
  };

  const update = (updatedItem) => {
    const items = getFieldValue(formName);

    setFields([
      {
        name: formName,
        value: items.map((item) =>
          item.edit
            ? {
                ...item,
                ...updatedItem,
                edit: false,
              }
            : item,
        ),
      },
    ]);
  };

  return (
    <Form.List name={name} rules={rules} style={style} className={s.displayFix} shouldUpdate>
      {(fields, { move, remove }) => (
        <>
          <Row align="middle" justify="space-between" style={titleStyle}>
            <Typography.Title level={titleLevel} note={withCount && fields?.length}>
              {label}
            </Typography.Title>
            {extra}
          </Row>

          {subtitle && (
            <div style={{ marginBottom: 30 }}>
              <Typography.Text level={3}>{subtitle}</Typography.Text>
            </div>
          )}

          <Sortable.List
            onDragEnd={({ source, destination }) => move(source.index, destination.index)}
            droppableId={droppableId}
            placeholder={withPlaceholder && !fields.length}
          >
            {fields.map((field, index) => {
              const value = getFieldValue([...formName, field.name]);
              const key = `${formName.join('.')}-${field.key}`;
              const handleRemove = () => {
                remove(index);
                if (name === 'relatedEvent' && onRelatedEventDelete) onRelatedEventDelete();
              };
              const handleEdit = () => edit(index);

              return value.edit ? (
                <EditPanel key={`${key}-edit`} item={value} update={update} close={closeEdit} remove={handleRemove} />
              ) : (
                <Sortable.ItemWithDelete key={key} draggableId={key} index={index} onDelete={handleRemove}>
                  {children(value, field, handleEdit)}
                </Sortable.ItemWithDelete>
              );
            })}
          </Sortable.List>
        </>
      )}
    </Form.List>
  );
};

export default SortableArrayField;
